(function () {
  const ZERO_CLASS = 'is-zero';
  const ROOT_SELECTOR = '.facets-sidebar';

  function updateFacetControls() {
    const controls = document.querySelectorAll(`${ROOT_SELECTOR} .checkbox-control`);
    controls.forEach(control => {
      const label = control.querySelector('label');
      if (!label) return;

      // Check for "(0)" anywhere in label text
      const isZero = /\(\s*0\s*\)/.test(label.textContent);
      control.classList.toggle(ZERO_CLASS, isZero);
    });
  }

  // Run periodically until we detect the drawer (polling approach)
  const interval = setInterval(() => {
    if (document.querySelector(ROOT_SELECTOR)) {
      updateFacetControls();
      clearInterval(interval);
    }
  }, 100);

  // Also watch for AJAX changes inside facets
  const observer = new MutationObserver(updateFacetControls);
  observer.observe(document.body, { childList: true, subtree: true });
})();



document.addEventListener("DOMContentLoaded", function() {
  function replaceLabels() {
    const elements = document.querySelectorAll(
      ".checkbox-control .text-subdued, .removable-facet .text-subdued"
    );

    elements.forEach(el => {
      const original = el.textContent || "";
      // Replace standalone Yes/No (case-insensitive), keep everything else (numbers, prefixes)
      const newText = original
        .replace(/\bYes\b/gi, "In Stock")
        .replace(/\bNo\b/gi, "Place Order");

      if (newText !== original) {
        console.log("Replacing:", JSON.stringify(original), "→", JSON.stringify(newText));
        el.textContent = newText;
      }
    });
  }

  // Run once on load
  replaceLabels();

  // Observe DOM changes (AJAX re-renders)
  const observer = new MutationObserver(replaceLabels);
  observer.observe(document.body, { childList: true, subtree: true });
});








